"use client";
import { Box, IconButton, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
// import CountDown from "../claim-service/CountDown";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { ApiService } from "@/app/services/AppService";
import {
  OfferService,
  ResponseObject,
  ViewDetailsServices,
} from "@/app/classes/main";
import { FormatedTime } from "../genericComponents/formated-time/FormatedTime";
import ViewDetails from "../genericComponents/view-details/ViewDetails";
import { AddToCartService } from "../../services/cart";
import { getHubId } from "../genericComponents/helper-functions/currencyCode";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import CountDown from "../claim-service/CountDown";
import "./index.css";

export const Offers = ({}) => {
  const [dealofDayData, setDealofDayData] = useState<OfferService | undefined>(
    undefined
  );
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<ViewDetailsServices | undefined>(undefined);
  const [reloadFlag, setReloadFlag] = useState(false);
  const apiService = useMemo(() => new ApiService(), []);
  const addTocartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();
  const xHubId = getHubId();

  const handleAddGift = async (e: any, index: any) => {
    e.stopPropagation();
    const service = dealofDayData?.servicesList?.[index];
    if (!service) {
      return;
    }
    let inCart = addTocartService.checkIfAvailableinCart(
      service.id ?? 0,
      service.cid ?? 0
    );
    if (inCart) {
      await addTocartService.addToCart(
        service.id ?? 0,
        false,
        service.cid ?? 0,
        service.coverImage?.secureHttpPath ?? "",
        service.aboutList,
        service.subHeading,
        service.serviceCharge,
        service.productCost,
        service.min,
        service.specialPrice,
        service.specialMessage
      );
    } else {
      await addTocartService.addToCart(
        service.id ?? 0,
        true,
        service.cid ?? 0,
        service.coverImage?.secureHttpPath ?? "",
        service.aboutList,
        service.subHeading,
        service.serviceCharge,
        service.productCost,
        service.min,
        service.specialPrice,
        service.specialMessage
      );
    }
    var newDealOfTheDay = { ...dealofDayData };
    newDealOfTheDay.servicesList = newDealOfTheDay?.servicesList?.map(
      (service: any, idx: any) => {
        if (idx === index) {
          return {
            ...service,
            inCart: addTocartService.checkIfAvailableinCart(
              service?.id,
              service?.cid
            ),
          };
        }
        return service;
      }
    );
    setDealofDayData(newDealOfTheDay);
    setReloadFlag(true);
  };

  const handleOpenViewDetails = (item: any) => {
    setData(item);
    setOpen(true);
  };

  const getDataDealOfTheDay = useCallback(async () => {
    try {
      const responseObject: ResponseObject | undefined =
        await apiService.get<ResponseObject>(
          apiService.dealOfTheDay,
          undefined,
          xHubId
        );
      const dealOfTheDay = responseObject?.object as OfferService | undefined;
      if (!dealOfTheDay) {
        setDealofDayData(undefined);
        return;
      }
      const rawList =
        dealOfTheDay.servicesList ??
        (dealOfTheDay as Record<string, unknown>).services;
      const servicesList = Array.isArray(rawList) ? rawList : [];
      if (servicesList.length === 0) {
        setDealofDayData(undefined);
        return;
      }
      (dealOfTheDay as { servicesList: typeof servicesList }).servicesList =
        servicesList;
      servicesList.forEach((service: any) => {
        service.inCart = addTocartService.checkIfAvailableinCart(
          service.id,
          service.cid
        );
      });
      setDealofDayData(dealOfTheDay);
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, addTocartService, xHubId]);

  useEffect(() => {
    getDataDealOfTheDay();
  }, [getDataDealOfTheDay]);

  return (
    <>
      {dealofDayData &&
      dealofDayData?.servicesList &&
      dealofDayData?.servicesList?.length > 0 ? (
        <Box
          sx={{
            marginTop: 0,
            width: "min(100%, var(--salontym-content-width))",
            maxWidth: "100%",
            boxSizing: "border-box",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "var(--salontym-section-gap)",
            background:
              "linear-gradient(135deg, rgba(16,33,23,0.98) 0%, rgba(20,61,42,0.95) 48%, rgba(91,45,31,0.92) 100%)",
            padding: {
              xs: "1.25rem 1.25rem 1rem",
              sm: "1.75rem 1.75rem 1.25rem",
              md: "1.75rem 2rem 1.35rem",
            },
            borderRadius: { xs: "22px", sm: "28px", md: "36px" },
            boxShadow: "0 26px 70px rgba(11, 26, 19, 0.18)",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "-4rem",
              right: "-4rem",
              width: "14rem",
              height: "14rem",
              borderRadius: "999px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 72%)",
            }}
          />
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#fff8f1",
                width: "100%",
                padding: 0,
                fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" },
              }}
              className="offer-heading"
            >
              Deal of the day
            </Typography>
            <Box
              sx={{
                width: "100%",
                color: "#fff8f1",
                mt: { xs: 1, sm: 1.25 },
                mb: { xs: 1.25, sm: 1.5 },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "1.05rem", sm: "1.2rem" },
                  lineHeight: 1.35,
                  maxWidth: "100%",
                }}
              >
                {dealofDayData?.heading}
              </Typography>
              {dealofDayData?.subheading ? (
                <Typography
                  sx={{
                    mt: 0.5,
                    color: "rgba(255,248,241,0.72)",
                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                    lineHeight: 1.45,
                    maxWidth: "min(100%, 52ch)",
                  }}
                >
                  {dealofDayData.subheading}
                </Typography>
              ) : null}
              {dealofDayData?.expireIn ? (
                <Box
                  className="deal-of-day-timer-pill"
                  sx={{
                    mt: 1.5,
                    display: "inline-flex",
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: { xs: 0.75, sm: 1 },
                    px: { xs: 1.15, sm: 1.35 },
                    py: 0.65,
                    borderRadius: "999px",
                    bgcolor: "rgba(0,0,0,0.35)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                    maxWidth: "100%",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="span"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: "0.1em",
                      textTransform: "uppercase",
                      fontSize: "0.65rem",
                      color: "rgba(255,248,241,0.92)",
                      flexShrink: 0,
                      lineHeight: 1,
                    }}
                  >
                    Ends in
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      lineHeight: 1,
                      minWidth: 0,
                    }}
                  >
                    <CountDown
                      expireIn={dealofDayData.expireIn}
                      offerTimerValid={true}
                      justifyContent="flex-start"
                      className="deal-of-day-countdown"
                    />
                  </Box>
                </Box>
              ) : null}
            </Box>
            <Box
              sx={{
                textAlign: "left",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  justifyContent: "flex-start",
                  flexWrap: "nowrap",
                  gap: { xs: "0.75rem", sm: "1rem" },
                  overflowX: "auto",
                  overflowY: "hidden",
                  width: "100%",
                  minWidth: 0,
                  paddingLeft: { xs: 0, sm: 0 },
                  paddingRight: { xs: 0, sm: 0 },
                  paddingBottom: "0.35rem",
                  boxSizing: "border-box",
                  WebkitOverflowScrolling: "touch",
                  "&::-webkit-scrollbar": {
                    height: 6,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "rgba(255,255,255,0.25)",
                    borderRadius: 3,
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "rgba(255,255,255,0.35) transparent",
                  msOverflowStyle: "auto",
                }}
              >
                {dealofDayData?.servicesList?.map((item: any, index: any) => {
                  const coverSrc =
                    item?.coverImage?.secureHttpPath?.trim() ||
                    item?.banner?.secureHttpPath?.trim() ||
                    "";
                  const previewBullets = (item?.aboutList ?? []).slice(0, 2);
                  return (
                    <Box
                      key={item?.id ?? `deal-${index}`}
                      className="deal-day-card"
                      onClick={() => handleOpenViewDetails(item)}
                      sx={{
                        flex: "0 0 auto",
                        width: { xs: "min(17rem, 86vw)", sm: "17.75rem" },
                        minWidth: { xs: "min(17rem, 86vw)", sm: "17.75rem" },
                        maxWidth: "100%",
                        borderRadius: "14px",
                        overflow: "hidden",
                        bgcolor: "rgba(8, 26, 18, 0.75)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        boxShadow: "0 14px 36px rgba(0,0,0,0.35)",
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        transition:
                          "transform 0.2s ease, box-shadow 0.2s ease",
                        "@media (hover: hover)": {
                          "&:hover": {
                            boxShadow: "0 20px 48px rgba(0,0,0,0.45)",
                            transform: "translateY(-3px)",
                          },
                        },
                      }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          height: 148,
                          flexShrink: 0,
                          bgcolor: "#0a1a12",
                        }}
                      >
                        {coverSrc ? (
                          // eslint-disable-next-line @next/next/no-img-element
                          <img
                            src={coverSrc}
                            alt={
                              item?.name
                                ? String(item.name)
                                : "Deal of the day service"
                            }
                            loading={index < 2 ? "eager" : "lazy"}
                            decoding="async"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                        ) : (
                          <Box
                            sx={{
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: "rgba(255,255,255,0.45)" }}
                            >
                              No image
                            </Typography>
                          </Box>
                        )}
                        <Box
                          sx={{
                            position: "absolute",
                            top: 10,
                            left: 10,
                            px: 1,
                            py: 0.35,
                            borderRadius: "999px",
                            background:
                              "linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)",
                            color: "#fff",
                            fontSize: "0.7rem",
                            fontWeight: 800,
                            lineHeight: 1.25,
                            boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
                          }}
                        >
                          {Math.floor(item?.discountInPercent ?? 0)}% off
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          p: 1.35,
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.85,
                          flex: 1,
                          minHeight: 0,
                          textAlign: "left",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.95rem",
                            lineHeight: 1.35,
                            color: "#fffdf7",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {item?.name}
                        </Typography>
                        {item?.subHeading ? (
                          <Typography
                            sx={{
                              fontSize: "0.78rem",
                              color: "rgba(255,248,241,0.68)",
                              lineHeight: 1.4,
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {item.subHeading}
                          </Typography>
                        ) : null}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "rgba(186, 230, 206, 0.95)",
                          }}
                        >
                          <WatchLaterIcon sx={{ fontSize: 17 }} />
                          <Typography variant="caption" sx={{ fontWeight: 600 }}>
                            <FormatedTime min={item?.min} />
                          </Typography>
                        </Box>
                        {previewBullets.length > 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.35,
                            }}
                          >
                            {previewBullets.map((line: string, bi: number) => (
                              <Box
                                key={bi}
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: 0.5,
                                }}
                              >
                                <CheckIcon
                                  sx={{
                                    color: "#6ee7b7",
                                    fontSize: "0.95rem",
                                    mt: "2px",
                                    flexShrink: 0,
                                  }}
                                />
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "rgba(255,255,255,0.88)",
                                    lineHeight: 1.35,
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {line}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        ) : null}
                        <Box
                          sx={{
                            mt: "auto",
                            pt: 1,
                            borderTop: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {item?.specialPrice ? (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#bbf7d0",
                                fontWeight: 700,
                                display: "block",
                                mb: 0.35,
                              }}
                            >
                              Special {currencyCode}
                              {item.specialPrice?.toLocaleString()}/-
                            </Typography>
                          ) : null}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "baseline",
                              gap: 0.75,
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontWeight: 800,
                                fontSize: "1rem",
                                color: "#fffdf7",
                                textDecoration: item?.specialPrice
                                  ? "line-through"
                                  : "none",
                                opacity: item?.specialPrice ? 0.85 : 1,
                              }}
                            >
                              {currencyCode}
                              {item?.amount?.toLocaleString() ?? "—"}/-
                            </Typography>
                            <Typography
                              component="span"
                              variant="caption"
                              sx={{
                                textDecoration: "line-through",
                                color: "rgba(251, 191, 36, 0.95)",
                                fontWeight: item?.specialPrice ? 500 : 600,
                              }}
                            >
                              {currencyCode}
                              {item?.mrp?.toLocaleString()}/-
                            </Typography>
                          </Box>
                          {item?.specialMessage ? (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "rgba(187, 247, 208, 0.95)",
                                display: "block",
                                mt: 0.35,
                              }}
                            >
                              {item.specialMessage}
                            </Typography>
                          ) : null}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              mt: 0.75,
                            }}
                          >
                            <IconButton
                              size="small"
                              aria-label={
                                item?.inCart ? "Remove from cart" : "Add to cart"
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAddGift(e, index);
                              }}
                              sx={{
                                bgcolor: "#fff",
                                color: "#15741a",
                                width: 40,
                                height: 40,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                "&:hover": {
                                  bgcolor: "#f0fdf4",
                                },
                              }}
                            >
                              {item?.inCart == null || !item?.inCart ? (
                                <AddIcon fontSize="small" />
                              ) : (
                                <CheckIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
          <ViewDetails
            open={open}
            setClose={() => setOpen(false)}
            imageUrl={
              data?.banner?.secureHttpPath ?? data?.coverImage?.secureHttpPath
            }
            heading={data?.name}
            id={data?.id}
            cid={data?.cid}
            servicedDetails={data?.aboutList}
            descriptions={data?.descriptions}
            amount={data?.specialPrice}
            min={data?.min}
            subHeading={data?.subHeading}
            mrp={data?.mrp}
            specialPrice={data?.specialPrice}
            specialMessage={data?.specialMessage}
            coin={data?.cashbackSalontymCoins}
            aboutList={data?.aboutList}
            serviceCharge={data?.serviceCharge}
            productCost={data?.productCost}
            reloadCartItemsFlag={() => {}}
            setReloadViewDetailsItem={() => setReloadFlag(false)}
            reloadViewDetailsItem={reloadFlag}
          />
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
